module.exports = __webpack_public_path__ + "img/region.934b859a.png";